import React, { useState, useEffect } from "react";
import BootstrapTable from "react-bootstrap-table-next";
import { useSelector } from "react-redux";
import { OverlayTrigger, Popover, Tooltip } from "react-bootstrap";
import GenericModal from "../../GenericComponents/GenericModal/GenericModal";
import TaskNotes from "../../GenericComponents/TaskNotes";
import moment from "moment";

const HelpList = ({ ...props }) => {
    const [showNotesModal, setShowNotesModal] = useState(false);
    const [notesModalData, setNotesModalData] = useState({});
    const profileData = useSelector((state) => state?.dashboard);

    const srNumberFormatter = (cell, row, rowIndex, formatExtraData) => {
        if (props.currentPage > 1)
            return <>{props.perPage * (props.currentPage - 1) + (rowIndex + 1)}</>;
        else return <>{rowIndex + 1}</>;
    };

    const nameFormatter = (cell, row) => {
        return (
            <>
                <div>
                    {" "}
                    {`${cell.firstName !== null ? cell.firstName : ""} ${cell.lastName !== null ? cell.lastName : ""
                        }`}
                </div>
            </>
        );
    };

    const dateFormatter = (cell, row) => {
        return `${moment(row.eventTimestamp).format("MM/DD/YYYY")}  ${moment(
            row.eventTimestamp
        ).format("hh:mm A")}`;
    };

    const notesFormatter = (cell, row) => {
        return (
            <OverlayTrigger
                placement="top"
                overlay={<Tooltip id="button-tooltip-3">Click To View Notes</Tooltip>}
            >
                <img
                    src="/images/pharmacy_workspace/notes_black_icn@2x.png"
                    alt=""
                    className="iconStyle"
                    style={{ cursor: "pointer" }}
                />
            </OverlayTrigger>
        );
    };

    const handleShowNotesModal = (show, data) => {
        if (show) {
            setNotesModalData(data);
        } else {
            setNotesModalData({});
        }
        setShowNotesModal(show);
    };

    const columns = [
        {
            dataField: "id",
            text: "No.",
            formatter: srNumberFormatter,
            headerStyle: () => {
                return { width: "48px" };
            },
        },
        {
            dataField: "eventTimestamp",
            text: "CALL ALERT DATE/TIME",
            formatter: dateFormatter,
        },
        {
            dataField: "address",
            text: "LOCATION",
        },
        {
            dataField: "notes",
            text: "NOTES",
            formatter: notesFormatter,

            headerStyle: () => {
                return { width: "120px" };
            },
            events: {
                onClick: (e, column, columnIndex, row, rowIndex) => {
                    handleShowNotesModal(true, row);
                },
            },
        },
    ];

    return (
        <div>
            <BootstrapTable
                keyField="id"
                data={props.helpList.sort((t1, t2) => {
                    if (t1.eventTimestamp > t2.eventTimestamp) return -1;
                    if (t1.eventTimestamp < t2.eventTimestamp) return 1;
                    return 0;
                })}
                columns={columns}
                striped
                hover
                condensed
                bordered={false}
            //defaultSorted={defaultSorted}
            />
            <GenericModal
                key="notes"
                showModal={showNotesModal}
                handleShowModal={handleShowNotesModal}
                ChildComponent={
                    <TaskNotes
                        data={notesModalData}
                        payload={{
                            patientId: notesModalData?.patientId,
                            noteModuleId: 1,
                            referenceId: notesModalData?.id,
                            eventTypeId: parseInt(notesModalData?.eventType),
                            patientTaskId: null,
                        }}
                        patientData={profileData?.profileData?.patientData}
                    />
                }
                variant={"white"}
            />
        </div>
    );
};

export default HelpList;
